export class ContributorPaymentLogFilterModel {
    public year: string;
    public month: string;

    constructor() {
        this.year = '';
        this.month = '';
    }
}
